import React, { useEffect, useState } from 'react'
import { Modal } from '../../atoms/modal'
import useModal from '../../../hooks/useModal'
import useQueryParams from '../../../hooks/useQueryParams'
import { CloseButton } from '../../atoms/closeButton'
import { StyledCloseButtonWrapper, StyledIframeWrapper } from './styles'
import { navigate } from 'gatsby'
import { If } from '../../atoms/if'
import { CAFSuccessStep } from '../../molecules/CAFSuccessStep'
import { useFeatureValue } from '@growthbook/growthbook-react'

export const CAFModal = () => {
  const { onboarding = '' } = useQueryParams()
  const { isOpen, openModal, closeModal } = useModal()
  const [step, setStep] = useState(0)
  const CAFModalBehavior = useFeatureValue('caf_modal_behavior')

  const url = atob(onboarding) || ''

  useEffect(() => {
    if (!CAFModalBehavior) return

    if (CAFModalBehavior === 'redirect' && url) {
      return navigate(url)
    }

    if (onboarding) openModal()
  }, [onboarding, CAFModalBehavior, url])

  useEffect(() => {
    window.addEventListener(
      'message',
      function (e) {
        if (e.data.code === 'ONBOARDING_FINISHED') {
          setStep(1)
        }
      },
      false
    )
  }, [])

  const handleClose = () => {
    closeModal()
    navigate('/')
  }

  return (
    <Modal isOpen={isOpen} fullScreen noPadding>
      <StyledCloseButtonWrapper>
        <CloseButton onClick={handleClose} />
      </StyledCloseButtonWrapper>
      <StyledIframeWrapper>
        <If
          condition={step === 0}
          render={() => (
            <iframe
              src={url}
              allow="camera;fullscreen;accelerometer;gyroscope;magnetometer;"
            />
          )}
        />
        <If
          condition={step === 1}
          render={() => <CAFSuccessStep onClose={handleClose} />}
        />
      </StyledIframeWrapper>
    </Modal>
  )
}
